import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useIdentity } from "@/auth/identity";
import { DriverProvider } from "@/context/DriverContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { ApiClientConfig } from "./components/ApiClientConfig";
import LoginPage from "./pages/LoginPage";
import Dashboard from "./pages/Dashboard";
import StartTrip from "./pages/StartTrip";
import EndTrip from "./pages/EndTrip";
import ReportAvailability from "./pages/ReportAvailability";
import MyAvailabilities from "./pages/MyAvailabilities";
import TripsHistory from "./pages/TripsHistory";
import Invoices from "./pages/Invoices";
import Coordination from "./pages/Coordination";
import ErrorPage from "./pages/ErrorPage";
import NotFound from "./pages/NotFound";
import { PushNotificationPrompt } from "./components/PushNotificationPrompt";

const queryClient = new QueryClient();

// Componente interno del DriverProvider
const AppContent = () => {
  const { isAuthenticated } = useIdentity();

  return (
    <>
      <ApiClientConfig />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
          <Route
            path="/start-trip"
            element={
              <ProtectedRoute>
                <StartTrip />
              </ProtectedRoute>
            }
          />
          <Route
            path="/end-trip"
            element={
              <ProtectedRoute>
                <EndTrip />
              </ProtectedRoute>
            }
          />
          <Route
            path="/report-availability"
            element={
              <ProtectedRoute>
                <ReportAvailability />
              </ProtectedRoute>
            }
          />
          <Route
            path="/my-availabilities"
            element={
              <ProtectedRoute>
                <MyAvailabilities />
              </ProtectedRoute>
            }
          />
          <Route
            path="/trips"
            element={
              <ProtectedRoute>
                <TripsHistory />
              </ProtectedRoute>
            }
          />
          <Route
            path="/invoices"
            element={
              <ProtectedRoute>
                <Invoices />
              </ProtectedRoute>
            }
          />
          <Route
            path="/coordination"
            element={
              <ProtectedRoute>
                <Coordination />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
      {/* Push notification prompt - only shown when authenticated */}
      {isAuthenticated && <PushNotificationPrompt />}
    </>
  );
};

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <DriverProvider>
          <AppContent />
        </DriverProvider>
      </TooltipProvider>
    </QueryClientProvider>
  );
};

export default App;
